var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3256 3.44438C14.5724 2.94432 15.2855 2.94432 15.5323 3.44438L18.727 9.91765C18.825 10.1162 19.0144 10.2539 19.2336 10.2857L26.3773 11.3237C26.9291 11.4039 27.1495 12.0821 26.7501 12.4713L21.5809 17.5101C21.4224 17.6646 21.35 17.8873 21.3874 18.1056L22.6077 25.2204C22.702 25.77 22.1251 26.1891 21.6315 25.9297L15.242 22.5705C15.046 22.4674 14.8119 22.4674 14.6159 22.5705L8.22635 25.9297C7.73276 26.1891 7.15588 25.77 7.25015 25.2204L8.47043 18.1056C8.50787 17.8873 8.43551 17.6646 8.27694 17.5101L3.10772 12.4713C2.7084 12.0821 2.92875 11.4039 3.4806 11.3237L10.6243 10.2857C10.8434 10.2539 11.0329 10.1162 11.1309 9.91765L14.3256 3.44438Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.896059,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteStar);
export default __webpack_public_path__ + "static/media/white-star.e90a23a8b7ed8e9ac870e7bcfeb594ae.svg";
export { ForwardRef as ReactComponent };